export class AttachmentTypes {
  public static readonly POLISA = "Polisa ubezpieczeniowa";
  public static readonly CERT = "Certyfikaty";
  public static readonly KOSZT = "Kosztorys";
  public static readonly INNE = "Inne";
  public static readonly DEFAULT = AttachmentTypes.INNE;
  public static readonly ALL = [
    AttachmentTypes.POLISA,
    AttachmentTypes.CERT,
    AttachmentTypes.KOSZT,
    AttachmentTypes.INNE
  ];
}

export class InvoiceTypes {
  public static readonly EINV = "einvoice";
  public static readonly HQ = "hq";
  public static readonly DEFAULT = InvoiceTypes.EINV;
  public static readonly ALL = [
    {
      id: InvoiceTypes.EINV,
      value: "e-faktura"
    },
    {
      id: InvoiceTypes.HQ,
      value: "siedziba firmy (Al. Jerozolimskie 100, Warszawa)"
    }
  ];
}
